import { StepWizardStep } from '../../../commons/StepWizard/StepWizard.types';
import LoginENTForm from './LoginENTForm/LoginENTForm';

export const loginCommercialSteps: StepWizardStep[] = [
  {
    step: 1,
    component: LoginENTForm,
    title: 'Connexion <secondary>entreprise</secondary>',
    subtitle: 'Entrez vos identifiants',
  },
];
